"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Used to set the tabs left position according to wrapper
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.grey8,
        paddingLeft: constants_1.WRAPPER_PADDING_LEFT,
        '&[data-has-modal=true]': {
            paddingTop: 0
        },
        '&[data-has-folder=true]': {
            borderRadius: '5px 5px 0px 0px',
            backgroundColor: theme.white,
            paddingLeft: 0
        }
    },
    tabsWrapper: {
        display: 'flex'
    },
    tabsElement: {
        '&[data-has-folder=true]': {
            backgroundColor: '#ECEBF2',
            borderRadius: '5px 5px 0px 0px'
        }
    },
    slider: {
        position: 'relative',
        borderBottom: `4px solid ${theme.grey1}`,
        transition: 'left 0.3s cubic-bezier(0.2, 0.86, 0.35, 1), width 0.3s cubic-bezier(0.3, 0.94, 0.21, 1.04);'
    },
    contentWrapper: {
        padding: 14,
        minHeight: 240,
        '&[data-is-centered=true]': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        '&[data-has-folder=true]': {
            backgroundColor: 'white',
            padding: 20,
            overflow: 'scroll',
            height: '93%'
        }
    }
});
//# sourceMappingURL=tabs.style.js.map